import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Marca', numeric: true, disablePadding: false, label: 'MARCA', show:true, fixed:false, width:250, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
    ];

    const variablesObject = {
        api:'/api/Marcas',
        apiMultiples:'/api/Marcas/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,   
        label:'MARCA',
        nameLocalStorage:'headersMarcasAC',
        order:'asc',
        orderBy:'Marca',
        OptionSearch:'Marca',
        rowsPerPage:15,
        Ruta:'/Almacen/Marcas',
        sumWidth:410,
        title:'MARCAS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;